import React, { useEffect, useState } from 'react';
import Styles from './main.module.scss';
import StylesM from './mIndex.module.scss';

interface ExceptionPageProps {
  /** 页面标题 */
  title: string;
  /** 倒计时结束或点击按钮时的回调 */
  onReturn?: () => void;
  /** 初始倒计时时间（秒） */
  countdown?: number;
  /** 按钮文本 */
  buttonText?: string;
  /** 是否为移动端 */
  isMobile?: boolean;
}

const ExceptionPage: React.FC<ExceptionPageProps> = ({
  title,
  onReturn,
  countdown: initialCountdown = 10,
  buttonText = '返回',
  isMobile = false
}) => {
  const [countdown, setCountdown] = useState(initialCountdown);
  const styles = isMobile ? StylesM : Styles;

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onReturn?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onReturn]);

  return (
    <div className={styles.exceptionPage}>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>
        您可以点击下方按钮返回大疆社区首页，{countdown} 秒后系统将自动跳转
      </p>
      <div
        className={styles.button}
        onClick={() => {
          onReturn?.();
        }}
      >
        {buttonText}
      </div>
    </div>
  );
};

export default ExceptionPage; 